import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Box } from '@components/common';
import { HeadLine } from '@components/Typography';
import { ModalContainer, ModalHeaderContainer } from '@containers/layout';
import SignKeyForm from '@containers/auth/SignKeyForm';
import DialogBox from '@components/DialogBox';
import AuthActions, { AuthSelectors } from '@redux/AuthRedux';
import ReadKeyRelease from '@containers/auth/ReadKeyRelease';

const PageWrapper = styled(Box)`
  background: white;
  min-width: 100vw;
  min-height: 100vh;
`;

function KeyReleaseModal(props) {
  const {
    user,
    isKeyReleaseSigned,
    show,
    dismiss,
    updateUserInfo,
    currentPropertyId
  } = props;
  const [showView, toggleView] = useState(false);

  const onSubmit = (signature, isSigned) => {
    if (isSigned) {
      updateUserInfo({
        ...user,
        isKeyReleaseSigned: true
      });
    }
    dismiss(signature);
  };

  return (
    <DialogBox show={show} onClickOutside={dismiss}>
      {!showView ? (
        <ModalContainer>
          <ModalHeaderContainer>
            <HeadLine textAlign="center">Accessing Your Apartment</HeadLine>
          </ModalHeaderContainer>

          <SignKeyForm
            user={user}
            isKeyReleaseSigned={isKeyReleaseSigned}
            onSubmit={onSubmit}
            onViewKey={() => {
              toggleView(true);
            }}
          />
        </ModalContainer>
      ) : (
        <PageWrapper>
          <ReadKeyRelease
            propertyID={currentPropertyId}
            onSubmit={() => toggleView(false)}
          />
        </PageWrapper>
      )}
    </DialogBox>
  );
}

KeyReleaseModal.propTypes = {
  user: PropTypes.object,
  isKeyReleaseSigned: PropTypes.bool,
  show: PropTypes.bool,
  dismiss: PropTypes.func,
  updateUserInfo: PropTypes.func,
  currentPropertyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

const mapStatesToProps = state => ({
  user: AuthSelectors.selectCurrentUser(state),
  isKeyReleaseSigned: AuthSelectors.selectIsKeyReleaseSigned(state),
  currentPropertyId: AuthSelectors.selectCurrentPropertyId(state)
});

const mapDispatchToProps = dispatch => ({
  updateUserInfo: user => dispatch(AuthActions.setUser(user))
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(KeyReleaseModal);
